import React from 'react'
import './LoadingIndicator.css'

const LoadingIndicator = () => {
  return (
    <div className="loading-indicator-analyze-external">
      <div className="spinner-analyze-external"></div>
    </div>
  )
}

export default LoadingIndicator
